import { render, staticRenderFns } from "./editar.vue?vue&type=template&id=527b9364&scoped=true"
import script from "./editar.vue?vue&type=script&lang=js"
export * from "./editar.vue?vue&type=script&lang=js"
import style0 from "./editar.vue?vue&type=style&index=0&id=527b9364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527b9364",
  null
  
)

export default component.exports